import type { MemberStatus, QuickCodeItem } from '@shared/api.interface';

/** 发给客户的话术：领取数量和有效期按会员类型自动带出，网址取当前站点（测试站/正式站各自正确） */
export function buildQuickCodeMessage(item: Pick<QuickCodeItem, 'passcode' | 'total_quota' | 'validity_months'>, host: string): string {
  return [
    `您的兑换码：${item.passcode}`,
    `打开 ${host}，点右上角“登录”输入兑换码，可任选 ${item.total_quota} 个主题领取，首次使用起 ${item.validity_months} 个月有效。`,
  ].join('\n');
}

export function quickCodeStatus(item: Pick<QuickCodeItem, 'status' | 'total_quota' | 'total_redemptions'>): { label: string; className: string } {
  const map: Record<MemberStatus, { label: string; className: string }> = {
    inactive: { label: '未使用', className: 'bg-stone-100 text-stone-600' },
    active: { label: '使用中', className: 'bg-claimed-soft text-claimed' },
    expired: { label: '已过期', className: 'bg-muted text-muted-foreground' },
    frozen: { label: '冻结', className: 'bg-amber-50 text-amber-800' },
    revoked: { label: '已作废', className: 'bg-red-50 text-red-700' },
  };
  if (item.status === 'active' && item.total_quota > 0 && item.total_redemptions >= item.total_quota) {
    return { label: '已用完', className: 'bg-sky-50 text-sky-800' };
  }
  return map[item.status];
}

/** 剪贴板接口被拒绝时（部分手机浏览器/内嵌页），退回到选中文本复制 */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch {
      ok = false;
    }
    area.remove();
    return ok;
  }
}
